import { HttpErrorResponse, HttpStatusCode } from '@angular/common/http';
import { ErrorHandler, Injectable, Injector, NgZone } from '@angular/core';
import { UNHANDLE_ERROR_MESSAGE } from '@core/utils/constants';
import { HotToastService } from '@ngneat/hot-toast';

@Injectable()
export class ErrorService implements ErrorHandler {
  private readonly ngZone: NgZone;

  constructor(private readonly injector: Injector) {
    this.ngZone = this.injector.get(NgZone);
  }

  get toastService() {
    return this.injector.get(HotToastService);
  }

  handleError(error: Error | HttpErrorResponse) {
    if (error instanceof HttpErrorResponse) {
      this.handleHttpError(error);
    }

    if (!navigator.onLine) {
      this.ngZone.run(() => this.toastService.error('Revisa tu conexión a internet'));
    }

    console.error(error);
  }

  private handleHttpError({ error: httpError, status }: HttpErrorResponse) {
    let message = httpError?.error?.mensaje || UNHANDLE_ERROR_MESSAGE;

    const isTimeout = [
      HttpStatusCode.GatewayTimeout,
      HttpStatusCode.RequestTimeout,
    ].includes(status);

    if (isTimeout) {
      message = 'La respuesta ha tardado en responder, inténtalo de nuevo.';
    }

    this.ngZone.run(() => {
      this.toastService.close();
      this.toastService.error(message);
    });
  }
}
